module.exports = __webpack_public_path__ + "alliance.55bc56aece8fb359b3e2a1c03796ab4c.svg";


//////////////////
// WEBPACK FOOTER
// ./components/events/assets/alliance.svg
// module id = 0z3O
// module chunks = 0